import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  coursesLength: 0,
  courses: [],
  course: {},
  courseError: "",
  formError: "",
};

export default function CourseReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_COURSE:      
      return { ...state, loading: action.payload };

    case actions.LOADING_COURSE_BY_ID:
      return { ...state, loadingById: action.payload };

    case actions.SAVE_LOADING_COURSE:
      return { ...state, saveLoading: action.payload };

    case actions.GET_COURSE:
      return {
        ...state,
        courses: action.payload.courses,
        coursesLength: action.payload.coursesLength,
      };

    case actions.GET_COURSE_BY_ID:
      return { ...state, course: action.payload };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.COURSE_FAIL:
      return { ...state, courseError: action.payload };

    default:
      return state;
  }
}
